import React from "react";
import "./styles/feature.css";
import FeatureBox from "../../components/FeatureBox";

const Features = () => {
  const content = [
    {
      img: "/images/survey.svg",
      title: "100+ surveys",
      content:
        "Real Opinion collaborates with top-tier survey providers, ensuring access to a premium surveys.",
    },
    {
      img: "/images/fast.svg",
      title: "Reliable payouts",
      content:
        "No one likes waiting — especially your users. Real Opinion offers quick and transparent withdrawals.",
    },
    {
      img: "/images/friendly.svg",
      title: "User-friendly UI",
      content:
        "The interface is clean, intuitive, and optimized for easy survey browsing.",
    },
    {
      img: "/images/bonus.svg",
      title: "USPs",
      content:
        "To further drive user retention, Real Opinion offers periodic bonuses, streak rewards.",
    },
  ];
  return (
    <div className="container feature-container">
      <p className="feature-small-title">our features</p>
      {/* <h1 className="feature-heading">Turn Every Click Into Revenue</h1>
      <p className="feature-para">
        Real Opinion empowers publishers with a simple way to grow their revenue
        by up to 3x. Our plug-and-play Surveywall.
      </p> */}
      <div className="feature-box-container">
        {content.map((val, i) => (
          <FeatureBox
            key={i}
            imgSrc={val.img}
            content={val.content}
            title={val.title}
          ></FeatureBox>
        ))}
      </div>
    </div>
  );
};

export default Features;
